import React from 'react';
import styled from 'styled-components';
import { BUTTON_THEMES } from './themes';
import { StTextLine } from './ButtonIconTextWidthAuto';
import { ProductGroupButton } from '../ProductGroupDropdown/ProductGroupButton';
import { BUTTON_SIZE_TYPES } from '../SegmentedButton';

const StButton = styled(ProductGroupButton)`
    width: auto;
`;

interface Props {
    children: React.ReactNode;
    className?: string;
    dataDisplayname?: string;
    disabled: boolean;
    onClick: () => void;
    size?: BUTTON_SIZE_TYPES[number];
    theme: (typeof BUTTON_THEMES)[number];
}

export const ButtonTextWidthAuto = (props: Props) => {
    return (
        <StButton
            data-displayname={props.dataDisplayname || null}
            disabled={props.disabled}
            onClick={props.onClick}
            size={props.size}
            theme={props.theme}
            className={props.className}
        >
            <StTextLine>{props.children}</StTextLine>
        </StButton>
    );
};
